import React from 'react'
import PropTypes from 'prop-types'

// moment
import moment from 'moment';

// @material-ui
import { Box, Card, CardContent, CardHeader, Fade, IconButton } from '@material-ui/core'
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { Attachment } from '@material-ui/icons'

import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';

// core
import { withLang } from '_core/hocs/withLang';

import NoteView from '_core/components/NoteView';


const useStyles = makeStyles((theme) => ({
  header: { },
  attachments: {
    'justify-content': 'left'
  }
}));

const RawPopupMessage = (props) => {
  const { message, onClose } = props;

  const [open, setOpen] = React.useState(true);

  const classes = useStyles();

  const handleClose = () => {
    setOpen(open => !open);
  };

  const handleTransitionEnd = (x) => {
    if (!open) {
      onClose();
    }
  }

  const timestamp = moment(message.timestamp)
    .format("hh:mm:ss DD.MM.yyyy");

  return (
    <Fade in={open} timeout={500} onExited={handleTransitionEnd}>
      <Card className={classes.root}>
        <CardHeader
          className={classes.header}
          component={Box}
          title={message.topic.subject}
          subheader={timestamp}
          titleTypographyProps={{ variant: "h6" }}
          action={
            <IconButton aria-label="close">
              <CloseIcon onClick={handleClose} />
            </IconButton>
          }
        />
        <CardContent>
          <NoteView>
            {message.content}
          </NoteView>
          <List dense={true}>
            {
              message.files.map(file => {
                const title = file.title;
                const path = file.path;

                return (
                  <ListItem button>
                    <ListItemIcon>
                      <Attachment />
                    </ListItemIcon>
                    <ListItemText primary={title} onClick={() => {
                      const link = document.createElement("a");
                      link.download = title;
                      link.href = path;
                      link.click();
                    }}/>
                  </ListItem>
                );
              })
            }
          </List>
        </CardContent>
      </Card>
    </Fade>
  );
}

RawPopupMessage.defaultProps = {}

RawPopupMessage.propTypes = {
  // self props
  message: PropTypes.object,

  // `withLang` HOC props
  langInfo: PropTypes.object,
  langStrings: PropTypes.object,
  getLangObject: PropTypes.func,
  getFirstLangString: PropTypes.func,
  getLangStringSet: PropTypes.func,
  getLangString: PropTypes.func.isRequired,
}

export const PopupMessage = withLang(
  (RawPopupMessage)
)
